import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import IVButton from '@invideoio/uniformd/components/Button';
import ivclass from '../../../../Modules/IVClass';
import HeaderConfig from '../../../../constants/header';
import { SharedContext } from '../../../../context/SharedProvider/SharedProvider';
import { formatUsername } from '../../../../utils/common';
import Title from './Title';
import { AnalyticsType } from '../../../../types/Analytics';
import { Analytics } from '../../../../utils/analytics';
import { logout } from '../../../../utils/auth';
import { sendRudderStackAnalyticsEvent } from '../../../../lib/BaseAnalyticsEvent';
const UserProfile = (props) => {
    const { onBack, logoutRedirectLink } = props;
    const { state } = useContext(SharedContext);
    const onUserLogout = () => {
        Analytics.send(AnalyticsType.AMPLITUDE, { eventName: 'log out' });
        sendRudderStackAnalyticsEvent({
            eventName: 'click_cta',
            eventProperties: {
                type: 'click_logout',
                ux_source: 'mobile_user_profile',
                feature_utm: 'na',
            },
        });
        logout(logoutRedirectLink);
    };
    return (state.user && (_jsxs(React.Fragment, { children: [_jsx("div", { className: ivclass('iv-py-25'), children: _jsx(IVButton, { className: ivclass('iv-flex', 'iv-items-center'), onClick: () => onBack(), children: _jsx(Title, { title: formatUsername(state.user.first_name, 20), icon: HeaderConfig.BACK_ICON_MOBILE }) }) }), _jsx("div", { className: ivclass('iv-pb-20'), children: _jsx("a", { href: HeaderConfig.HEADER_LINKS.userProfile, target: "_self", className: ivclass('iv-text-grey-50', 'iv-m-body-2xl', 'iv-text-body-2xl', 'iv-font-medium'), children: "Profile" }) }), _jsx("div", { className: ivclass('iv-pb-20'), children: _jsx(IVButton, { className: ivclass('iv-text-grey-50', 'iv-m-body-2xl', 'iv-text-body-2xl', 'iv-font-medium'), onClick: onUserLogout, children: "Log out" }) })] })));
};
export default UserProfile;
